import React from 'react'
import * as S from './styles'
import { useCallback, useMemo } from 'react'
import Tabs, { Tab } from '../../molecules/Tabs'
import { useHistory, useLocation } from 'react-router-dom'
import { ChannelHelper, intersect, isString } from '@monorepo/infra'
import { IReactSelectOption } from '@monorepo/interfaces'
import ChannelHomepageCarouselTemplate from './ChannelHomepageCarousel'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

const tabs: Tab[] = intersect(
    ChannelHelper.getChannelOptions(),
    ChannelHelper.useCarousel,
    (left: IReactSelectOption, right: string) =>
        isString(left.value) &&
        isString(right) &&
        left.value.trim().toUpperCase() === right.trim().toUpperCase()
).map((x) => ({
    label: x.label,
    value: x.value,
    content: (
        <>
            <ChannelHomepageCarouselTemplate channel={x.value} />
        </>
    ),
}))

const HomepageCarouselTemplate: React.FC = () => {
    const history = useHistory()
    const location = useLocation()
    const query = useMemo(
        () => new URLSearchParams(location.search),
        [location.search]
    )
    const initialTabValue = useMemo(() => query.get('tab'), [query])

    const handleTabChanged = useCallback(
        (newTabValue: string) => {
            const newQueryParams = new URLSearchParams(location.search)
            newQueryParams.set('tab', newTabValue)
            history.push({ search: newQueryParams.toString() })
        },
        [history, location.search]
    )

    const handleBack = useCallback(() => {
        history.push('/admin')
    }, [history])

    return (
        <>
            <S.MainBox>
                <S.TitleSection>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <S.BackButton onClick={handleBack} aria-label="Back to Admin">
                            <ArrowBackIcon />
                        </S.BackButton>
                        <S.TitleH1>HOMEPAGE CAROUSEL</S.TitleH1>
                    </div>
                </S.TitleSection>
                <Tabs
                    tabs={tabs}
                    initialTabValue={initialTabValue ?? ''}
                    onTabChanged={handleTabChanged}
                />
            </S.MainBox>
        </>
    )
}

export default HomepageCarouselTemplate
